// ======================
// LabelChip
// ======================

import { Chip, Stack, Typography, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { BlackTooltip } from "../../common/tooltip/ColorTooltip";
import { useTranslation } from "react-i18next";

interface LabelChipProps {
    label: string;
    description?: string;
    color: string;
    onClick?: () => Promise<any>;
    hostCount?: number;
    migrationSessionCount?: number;
    migrateOpsCount?: number;
}

export const LabelChip: React.FC<LabelChipProps> = (p) => {
    const { label, description, color, onClick, hostCount, migrationSessionCount, migrateOpsCount } = p;
    const theme = useTheme();
    const { t } = useTranslation("labels");

    const showHostMigrationCount = useMemo(() => {
        return hostCount !== undefined && migrationSessionCount !== undefined && migrateOpsCount != undefined;
    }, [hostCount, migrationSessionCount, migrateOpsCount]);

    const chip = (
        <Chip
            size={"small"}
            clickable={!!onClick}
            onClick={onClick || null}
            sx={{
                backgroundColor: color || null,
                color: color ? theme.palette.getContrastText(color) : "white",
            }}
            label={
                <Typography variant={"subtitle2"} fontWeight={600}>
                    {label}
                </Typography>
            }
        />
    );

    return (
        <BlackTooltip
            arrow
            title={
                <Stack spacing={1}>
                    <Stack>
                        <Typography variant={"body2"} color={"textSecondary"}>
                            {t("tooltip.description")}
                        </Typography>
                        <Typography variant={"body2"}>{description || t("common:format.unavailable")}</Typography>
                    </Stack>
                    {showHostMigrationCount && (
                        <Stack>
                            <Typography variant={"body2"} color={"textSecondary"}>
                                {t("tooltip.currentlyUsedOn")}
                            </Typography>
                            <Typography variant={"body2"} color={"primary"}>
                                {t("counts.host", { count: hostCount ?? 0 })}
                            </Typography>
                            <Typography variant={"body2"} color={"primary"}>
                                {t("counts.migrationSession", { count: migrationSessionCount ?? 0 })}
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            }
        >
            {chip}
        </BlackTooltip>
    );
};
